import React, {useState, useRef, useEffect} from 'react';
import styles from './TooltipRight.module.css';

const TooltipRight = ({text, children, link, backgroundColor, borderRadius = '12px'}) => {
    const [hovered, setHovered] = useState(false);
    const [tooltipStyle, setTooltipStyle] = useState({});
    const [arrowStyle, setArrowStyle] = useState({});
    const tooltipRef = useRef(null);

    const showTooltip = () => setHovered(true);
    const hideTooltip = () => setHovered(false);

    useEffect(() => {
        if (!hovered || !tooltipRef.current) {
            setTooltipStyle({});
            setArrowStyle({});
            return;
        }

        const tooltipRect = tooltipRef.current.getBoundingClientRect();
        const {innerWidth, innerHeight} = window;
        const offset = 8;


        let newStyle = {
            top: '50%',
            left: `calc(100% + ${offset + 23}px)`,
            transform: 'translateY(-50%)',
        };

        let newArrowStyle = {
            top: '50%',
            left: 0,
            transform: 'translate(-100%, -50%)',
            backgroundColor: 'transparent'
        };


        if (tooltipRect.right > innerWidth - offset) {
            const pushX = tooltipRect.right - (innerWidth - offset);
            newStyle.transform = `translateY(-50%) translateX(-${pushX}px)`;
            newArrowStyle.transform = `translate(-100%, -50%) translateX(${pushX}px)`;
        }


        if (tooltipRect.top < offset) {
            const pushY = offset - tooltipRect.top;
            newStyle.transform += ` translateY(${pushY}px)`;
            newArrowStyle.transform += ` translateY(-${pushY}px)`;
        }
        else if (tooltipRect.bottom > innerHeight - offset) {
            const pushY = tooltipRect.bottom - (innerHeight - offset);
            newStyle.transform += ` translateY(-${pushY}px)`;
            newArrowStyle.transform += ` translateY(${pushY}px)`;
        }

        setTooltipStyle(newStyle);
        setArrowStyle(newArrowStyle);
    }, [hovered]);

    return (
        <div
            className={styles.tooltipWrapper}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            style={{background: 'transparent'}}
        >
            {children}
            {hovered && (
                <div
                    className={styles.tooltip}
                    ref={tooltipRef}
                    style={{
                        ...tooltipStyle,
                        '--tooltip-bg': backgroundColor,
                        '--tooltip-border-radius': borderRadius,
                    }}
                >
                    {text}
                    {link && (
                        <a
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                            className={styles.learnMoreLink}
                        >
                            Learn More
                        </a>
                    )}
                    <div className={styles.arrow} style={arrowStyle}/>
                </div>
            )}
        </div>
    );
};

export default TooltipRight;